export enum UserRoles {
  SystemAdmin = 'SystemAdmin',
  Supervisor = "Supervisor",
  Attendant = 'Attendant',
}

export enum Features {
  USER_MANAGEMENT_VIEW = 'USER_MANAGEMENT_VIEW',
  CALL_MONITORING_VIEW = 'CALL_MONITORING_VIEW',
  ASSIGN_SUPERVISORS_FOR_Q_MONITORING = 'ASSIGN_SUPERVISORS_FOR_Q_MONITORING',
}

type IPlanPermissions = {
  [key in UserRoles]: Array<Features>
}

const PlanPermissions: IPlanPermissions = {
  [UserRoles.Attendant]: [],
  [UserRoles.Supervisor]: [
    Features.CALL_MONITORING_VIEW,
  ],
  [UserRoles.SystemAdmin]: [
    Features.USER_MANAGEMENT_VIEW,
    Features.ASSIGN_SUPERVISORS_FOR_Q_MONITORING,
  ],
};

export const canAccess = (plan: UserRoles, feature: Features): boolean => {
  return PlanPermissions[plan]?.includes(feature) ?? false;
};